module.exports = __webpack_public_path__ + "static/media/Jeida2.015df490.jpg";